import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import usePublicLocale from "../i18n/usePublicLocale";

/** Shared bottom navigation for every public page. */
export default function PublicFooterNav({
  sx,
  variant = "default",
  centerContent,
}) {
  usePublicLocale(["landing"]);
  const { t } = useTranslation("landing");
  const isProfile = variant === "profile";

  const links = isProfile
    ? [
        { key: "privacy", to: "/privacy" },
        { key: "terms", to: "/terms" },
      ]
    : [
        { key: "tools", to: "/tools" },
        { key: "invest", href: "https://recin.pl", external: true },
        { key: "faq", to: "/faq" },
        { key: "contact", to: "/contact" },
        { key: "terms", to: "/terms" },
        { key: "privacy", to: "/privacy" },
        { key: "rss", to: "/feeds" },
      ];

  return (
    <Box
      component="nav"
      className={isProfile ? "public-footer-nav--profile" : undefined}
      sx={{
        ...(isProfile
          ? {
              display: "grid",
              gridTemplateColumns: "1fr auto 1fr",
              alignItems: "center",
              gap: 2,
            }
          : {
              display: "flex",
              gap: 0.5,
              justifyContent: "center",
              flexWrap: "wrap",
            }),
        mt: { xs: 6, md: 9 },
        pt: 4,
        borderTop: "1px solid",
        borderColor: "divider",
        ...sx,
      }}
    >
      {isProfile && (
        <Typography component="span" className="public-footer-nav__copyright">
          © {new Date().getFullYear()} Recin p.s.a.
        </Typography>
      )}
      {isProfile && (
        <Box className="public-footer-nav__socials">{centerContent}</Box>
      )}
      <Box className={isProfile ? "public-footer-nav__links" : undefined}>
        {links.map((link) =>
          link.external ? (
            <Button
              key={link.key}
              component="a"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
              size="small"
              sx={{ color: "text.secondary" }}
            >
              {t(`nav.${link.key}`, { defaultValue: link.key.toUpperCase() })}
            </Button>
          ) : (
            <Button
              key={link.key}
              component={RouterLink}
              to={link.to}
              variant="text"
              size="small"
              sx={{ color: "text.secondary" }}
            >
              {t(`nav.${link.key}`, { defaultValue: link.key.toUpperCase() })}
            </Button>
          ),
        )}
      </Box>
    </Box>
  );
}
